import { Validator } from 'vee-validate';
import detectDeviceMixin from '../../common/mixins/detect-device-mixin';
import RegistrationLoginService from '../../common/services/registration-login-service';
import loginMixin from '../../common/mixins/login-mixin';
import globals from '../../common/globals';
import { duplicateMailErrorCode } from '../../common/mixins/vx-enums';

/**
 * Component used for updating email
 */
export default {
  name: 'vx-update-email',
  components: {},
  mixins: [detectDeviceMixin, loginMixin, duplicateMailErrorCode],
  props: {
    i18n: {
      type: Object,
    },
    updateEmailData: {
      type: Object,
    },
  },
  data() {
    return {
      isDuplicateMail: false,
      emailID: '',
      registrationLoginService: new RegistrationLoginService(),
      duplicateMailErrorCode,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    /**
     * This function is called on clicking submit button.
     * Firstly validated the form data on success makes a call to register user.
     */
    updateEmailID() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const requestConfig = {};
          requestConfig.data = {
            fbUniqueId: this.updateEmailData.fbUniqueId,
            firstName: this.updateEmailData.firstName,
            lastName: this.updateEmailData.lastName,
            fbMobileAccount: true,
            uid: this.emailID,
          };
          this.$emit('email-update-initiate');
          this.registrationLoginService.registerUser(
            requestConfig,
            this.handleRegisterResponse,
            this.handleRegisterError,
          );
        }
      });
    },
    /**
     * Handles the register user response
     * @param {Object} res contains the updated user data
     */
    handleRegisterResponse(res) {
      this.$emit('email-updated');
    },
    /**
     * Called on failure of the reister user call.
     * @param {Object} err caontains the error data sucs as error code, staus message.
     */
    handleRegisterError(err) {
      this.$emit('hide-spinner');
      if (
        err.response.data.errors[0].code ===
        this.duplicateMailErrorCode.DUP_EMAIL_ERROR_CODE
      ) {
        this.isDuplicateMail = true;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/registration-login/vx-update-email/vx-update-email.js